import TextFieldComponent from '@/Inputs/TextFieldComponent';
import { useFormikContext } from 'formik';
import React from 'react';
import { useState,useEffect } from 'react';

function CheckoutStepOne(props) {
    const { webAliesError, isUserLogin, userData, setWebAliesErros, rankUpgrad, setFormData, loginErrorMsg,_webAliesCheckDuringSubmit,webAliasInput, setWebAliasInput } = props;
    const fieldValue = useFormikContext();

    return (
        <div className='flex flex-wrap sm:gap-x-4'>
            {!isUserLogin &&
                <>
                    <TextFieldComponent
                        name="shipping_urname"
                        type='text'
                        label="First name"
                        value={fieldValue?.values?.shipping_urname}
                        onChange={(e) => {
                            fieldValue?.handleChange(e);
                            props?.handleChangeFunction(e, fieldValue?.values);
                        }}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            props?.handleChangeFunction(e, fieldValue?.values)
                        }}
                        errorMessage={fieldValue?.errors?.shipping_urname}
                        divClass={"sm:w-[calc(100%/2-8px)] w-full"}
                    />
                    <TextFieldComponent
                        name='shipping_lastname'
                        type='text'
                        label="Last name"
                        value={fieldValue?.values?.shipping_lastname}
                        onChange={(e) => {
                            fieldValue?.handleChange(e);
                            props?.handleChangeFunction(e, fieldValue?.values);
                        }}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            props?.handleChangeFunction(e, fieldValue?.values)
                        }}
                        errorMessage={fieldValue?.errors?.shipping_lastname}
                        divClass={"sm:w-[calc(100%/2-8px)] w-full"}
                    />
                </>}
                {rankUpgrad === 'main_enrollment' && !userData?.webAlias && (
                <div className="w-full">
                    <div className="md-3-field xl:mb-[24px] mb-[24px]">
                    <TextFieldComponent
                        name="webAlias"
                        type="text"
                        readOnly={!!userData?.webAlias}
                        label="Your Web Alias"
                        value={webAliasInput}
                        id="webAlias"
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^\w]/gi, ''); // Only alphanumeric characters allowed
                            setWebAliasInput(value);

                            // Validation logic for web alias
                            let errorMessage = '';

                            // Check for minimum length
                            if (value.length < 3) {
                                errorMessage = 'WebAlias must be at least 3 characters long.';
                            }
                            // Check if the value contains "Viago" (case insensitive)
                            else if (/Viago/i.test(value)) {
                                errorMessage = 'WebAlias cannot contain the word "Viago".';
                            }

                            // Set the error message into the state
                            setWebAliesErros((prevState) => ({
                                ...prevState,
                                isWebAliesError: errorMessage, // Update error state
                            }));

                            // Update the form field value and trigger any necessary handlers
                            fieldValue?.handleChange({
                                ...e,
                                target: {
                                    ...e.target,
                                    value,
                                    name: 'webAlias',
                                },
                            });

                            setFormData({ ...fieldValue?.values, webAlias: value });
                        }}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            props?.handleChangeFunction(e, fieldValue?.values);

                            const value = e.target.value.trim();
                            if (value) {
                             
                                let errorMessage = '';

                                if (value.length < 3) {
                                    errorMessage = 'WebAlias must be at least 3 characters long.';
                                } else if (/Viago/i.test(value)) {
                                    errorMessage = 'WebAlias cannot contain the word "Viago".';
                                }

                              
                                setWebAliesErros((prevState) => ({
                                    ...prevState,
                                    isWebAliesError: errorMessage, 
                                }));
                            }
                        }}
                        error={
                            !!webAliesError.isWebAliesError || 
                            !!fieldValue?.errors?.webAlias
                        }
                        errorMessage={
                            webAliesError.isWebAliesError || 
                            fieldValue?.errors?.webAlias
                        }
                        divClass="w-full !mb-0 border-clr border-[1px] px-3.5 pt-6 pb-1 rounded-[6px] relative"
                        classes={`!border-0 !p-0 w-full ${
                            !!userData?.webAlias && '!text-gray-500'
                        }`}
                        inputPar="static w-full flex"
                        cstmError="absolute left-0 top-[calc(100%+24px)] mt-0"
                    />
                    <span className="mt-1.5 block text-[12px] leading-[1.2]">
                        (You will share this link with others you bring in)
                    </span>
                    </div>
                    {loginErrorMsg?.includes('WebAlias') && (
                    <p className="text-sm !text-red-500">{loginErrorMsg}</p>
                    )}
                </div>
            )}

        </div >
    )

}

export default CheckoutStepOne